import { toast, updateBaseOptions } from '@ui-kit/scripts/configs/notify-config'
import { TOASTER_TIME } from '@/scripts/app-configs/constants'
import { segment } from '@/utils/segment'
import { EVENT_KEYS } from '@/utils/segment/segment-events'
import { UI_BLOCKERS } from '@/utils/segment/schemas/ui-blocker'

updateBaseOptions({
  timeout: TOASTER_TIME,
  pauseOnFocusLoss: false,
})

const $notify = {
  ...toast,
  error(message, options = {
    trackError: false,
    segmentPayload: {
      error: null,
      programUuid: null,
    },
  }) {
    const { trackError, segmentPayload } = options

    toast.error(message)

    if (!trackError) return

    segment.trackEventWithUser(EVENT_KEYS.UI_BLOCKER, {
      blocker: UI_BLOCKERS.ERROR_ALERT,
      request: segmentPayload?.error?.config?.url,
      programUuid: segmentPayload?.programUuid?.toString(),
    })
  },
}

export { $notify }

export default {
  install(app) {
    app.config.globalProperties.$notify = $notify
  },
}
